import { FC, ReactNode } from 'react';

import { usePolling } from '@/features/polling/hooks/usePolling';

export const PollingProvider: FC<{ children: ReactNode }> = ({ children }) => {
  usePolling();
  return <>{children}</>;
};
